import type React from "react";
import { RingProgress, Text, Tooltip } from "@mantine/core";

interface ScoreRingProps {
  /** 0 to 100; `null` when there is no measured score. */
  value: number | null;
  label: string;
  color: string;
  hint?: string;
}

/** A hit's score as a small ring with the number inside. */
const ScoreRing: React.FC<ScoreRingProps> = ({ value, label, color, hint }) => {
  const ring = (
    <RingProgress
      size={48}
      thickness={4}
      roundCaps
      sections={value === null ? [] : [{ value: Math.max(0, Math.min(100, value)), color }]}
      label={
        <Text ta="center" size="xs" fw={700} c={value === null ? "dimmed" : color}>
          {label}
        </Text>
      }
    />
  );
  return hint ? (
    <Tooltip label={hint} multiline maw={280} withArrow>
      <div>{ring}</div>
    </Tooltip>
  ) : (
    ring
  );
};

export default ScoreRing;
